import { Component, EventEmitter, Output } from '@angular/core';
import { ModalConfig } from '@df/ui/modal/modal-config';
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NModalLayoutLeft {
    /**
     * Default setup for left side modal
     */
    export const ModalConfig: ModalConfig = {
        closeOnNavigation: true,
        minWidth: undefined,
        maxWidth: undefined,
        position: {
            top: '0',
            left: '0'
        },
        transformOptions: 'translate3d(-100%, 0px, 0px)',
        transitionOptions: '500ms ease-in-out',
        hasBackdrop: true,
        scrollStrategy: 'noop'
    };
}
@Component({
    selector: 'modal-layout-left',
    templateUrl: 'modal-layout-left.html',
    styleUrls: ['modal-layout-left.scss'],
    standalone: true
})
export class ModalLayoutLeftComponent {
    @Output('close')
    closeEmitter = new EventEmitter<void>();
    close() {
        this.closeEmitter.next();
    }
}
